interface payRecords {
  is_Duplicate: number;
  Pay_frequency: { value: string } | null;
  Pay: number | string | null;
}

export const VALID_PAY_FREQUENCIES = {
  Monthly: 'Monthly',
  Weekly: 'Weekly',
  Bi_Weekly: 'BiWeekly',
  Bi_Monthly: 'BiMonthly',
  OneTime: 'OneTime',
  Yearly: 'Yearly',
} as const;

const payMultiplier: Record<string, number> = {
  [VALID_PAY_FREQUENCIES.Monthly]: 1,
  [VALID_PAY_FREQUENCIES.Weekly]: 52 / 12,
  [VALID_PAY_FREQUENCIES.Bi_Weekly]: 26 / 12,
  [VALID_PAY_FREQUENCIES.Bi_Monthly]: 2,
  [VALID_PAY_FREQUENCIES.Yearly]: 1 / 12,
  [VALID_PAY_FREQUENCIES.OneTime]: 1 / 12,
};

const CalculateMonthlyPay = (payRecords: payRecords[] = []): number => {
  return payRecords.reduce((total, { is_Duplicate, Pay_frequency, Pay }) => {
    if (is_Duplicate === 1) return total;
    
    const payAmount = Number(Pay) || 0;
    const freqValue = (Pay_frequency?.value) ? Pay_frequency?.value.trim() : VALID_PAY_FREQUENCIES.OneTime;
    if (!freqValue || !(freqValue in payMultiplier)) return total;
    const multiplier = payMultiplier[freqValue] ?? 1;
    return total + payAmount * multiplier;
  }, 0);
};

export default CalculateMonthlyPay;